import classNames from 'classnames';
import React from 'react';

import {Badge} from '@albert-io/atomic';
import type {DueDateResult} from 'lib/timeUtils';
import type {IconProp} from '@albert-io/atomic/atoms/Icon/Icon.react';

export function DueDateBadge({dueDateInfo}: {dueDateInfo: DueDateResult}) {
  const {isPastDue, color} = dueDateInfo;
  const icon: IconProp = isPastDue ? ['far', 'exclamation-triangle'] : ['far', 'clock'];
  return (
    <Badge
      status={color}
      emphasis='subtle'
      icon={icon}
      className={classNames({
        'content-primary': !isPastDue
      })}
    >
      {dueDateInfo.text}
    </Badge>
  );
}
